module.exports = __webpack_public_path__ + "img/product-kr-cardBg-red.f76f022.png";